import { render, staticRenderFns } from "./Product-BSYD.vue?vue&type=template&id=de132160&scoped=true"
import script from "./Product-BSYD.vue?vue&type=script&lang=js"
export * from "./Product-BSYD.vue?vue&type=script&lang=js"
import style0 from "./Product-BSYD.vue?vue&type=style&index=0&id=de132160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de132160",
  null
  
)

export default component.exports